import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { ProductShell, Button } from '@cloudgenie/ui';
import { API_BASE } from '../AuthContext';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      await fetch(`${API_BASE}/api/auth/forgot-password`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      // Always show the same message regardless — no user enumeration.
      setSent(true);
    } finally {
      setBusy(false);
    }
  }

  if (sent) {
    return (
      <ProductShell product="id" title="Check your email" subtitle="If an account matches that email, a reset link is on its way.">
        <div className="max-w-sm mx-auto text-center space-y-4">
          <p className="text-sm text-muted-foreground" data-testid="forgot-sent">
            We've sent a reset link to <strong>{email}</strong>. It expires in 24 hours.
          </p>
          <Link to="/login" data-testid="link-back-login"><Button variant="outline">Back to sign in</Button></Link>
        </div>
      </ProductShell>
    );
  }

  return (
    <ProductShell product="id" title="Reset your password" subtitle="Enter your email and we'll send a reset link.">
      <form onSubmit={submit} className="max-w-sm mx-auto space-y-4" data-testid="forgot-form">
        <div>
          <label className="block text-sm font-medium mb-1" htmlFor="email">Email</label>
          <input id="email" data-testid="forgot-email" type="email" required autoComplete="email"
            value={email} onChange={(e) => setEmail(e.target.value)}
            className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm" />
        </div>
        <Button variant="primary" type="submit" disabled={busy || !email} data-testid="forgot-submit">
          {busy ? 'Sending…' : 'Send reset link'}
        </Button>
        <p className="text-center text-sm text-muted-foreground">
          <Link to="/login" className="text-primary hover:underline">Back to sign in</Link>
        </p>
      </form>
    </ProductShell>
  );
}
